import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { getTemplateName } from "../../../../helpers/templates";
import { useTemplates } from "../../../../hooks/useTemplates";
import { Booking } from "api/types";
import { FALLBACK_VALUE } from "components/Table";

export const SlotTemplate = ({
  templateId,
  method,
}: {
  templateId: number;
  method: Booking["status"];
}) => {
  const { data: templates } = useTemplates();
  const { t } = useTranslation();
  const template = templates.find((i) => i.templateId === templateId);

  if (!template) return FALLBACK_VALUE;

  return (
    <Flex>
      {`${t(method)} ${getTemplateName(template?.name ?? "", t).toLowerCase()}`}
    </Flex>
  );
};

const Flex = styled.div`
  display: flex;
  align-items: center;
`;
